import * as amplify from "../util/amplify.ts";
import * as INR from "../INR.ts";
import ApiServer from "../ApiServer.js";
import {EventStore} from "../server/EventStore.js";
import * as modal from "../util/modal.ts";
import * as FwDatas from "../FwDatas.ts";
import * as Html from "../util/Html.ts";
import * as calendar_modal from "./calendar_modal.js";
import * as libLocation from "../lib/location.ts";
import * as i18n from "../i18n.ts";
import * as DateUtils from "../lib/DateUtils.ts";
import * as Storage from "../lib/Storage.ts";
import * as actionMenu from "../widget/action-menu-registry.ts"
import Icons from "../svg/Icons.ts"
import deviceId from "../lib/deviceId.js";
import { OS } from "../lib/os.js";
import FizConfig from "../FizConfig.js";

//timetable are used in calendar page so we need all this
import "../timetable/page_timetable.js";

import  {Calendar, ResourceApi, selectionInfo, ViewImpl} from "../lib/fullcalendar/all.ts";
import $ from "../$.js";
import { eventDrop, eventModified } from "./fullcalendar_dragdrop.js";
import { calendarclean, checkEventLimit } from "./calendarclean.js";
import { MemberOrder, memberToggleFilter } from "../util/MemberOrder.ts";
import { getComputedColorVariable } from "../lib/Css.ts";

var navigationContext = {
  page:0,
  pageCount:1
}
actionMenu.register({
  calendarsettings(){
    return {
      menu:[
        {svg:Icons.ic_settings,onclick:'calendarsettings',i18nkey:'headings.settings'},
        {svg:Icons.ic_print,onclick:'print',i18nkey:'actions.print'},
        {svg:Icons.calendar.ic_calendar_cleanup,onclick:'calendarclean',i18nkey:'actions.clean'}
      ]}
  },
  calendarview(){
    const isPremium = FwDatas.getState().premium.audio;
    return {
      position:"right",
      menu:[
        {svg:Icons.calendar.ic_calendar_view_day,onclick:'calendarview|timeGridDay',i18nkey:'eventCalendarNav.day'},
        {svg:isPremium?Icons.calendar.ic_calendar_view_member:Icons.premium.ic_premium_crown,onclick:'calendarview|resourceTimeGridDay',i18nkey:'eventCalendarNav.schedule'},
        {svg:Icons.calendar.ic_calendar_view_week,onclick:'calendarview|timeGridWeek',i18nkey:'eventCalendarNav.week'},
        {svg:Icons.calendar.ic_calendar_view_month,onclick:'calendarview|dayGridMonth',i18nkey:'eventCalendarNav.month'},
        {svg:Icons.calendar.ic_calendar_view_year,onclick:'calendarview|listYear',i18nkey:'eventCalendarNav.planning'},
      ]}
  }
})
  var
  // Constants
  selectedCalendarIds,
  currentFullCalendar;



INR.onPage(INR.URL.EVENTS_OUTLOOKRETURN,function(){
  var 
    error = libLocation.getURLParam('error'),
    code = libLocation.getURLParam('code');
  if(error){
    modal.oops('fw2.defaultError')
    ApiServer.webjslog('outlookreturn error '+error)
  }else if(code){
    ApiServer.outlooklogin(code,function(credential){
      import("../modal/caloutlook_edit.mustache").then(function(TPL){
        modal.openModal(TPL,credential);
      });
    },function(){
      libLocation.goTo('events.php');
    })
  }else{
    ApiServer.webjslog('outlookreturn without error nor code')
  }  
  libLocation.goTo('events.php');
})
Html.register({
  
  calendartoday() {
    currentFullCalendar.today();
    amplify.publish("calendar.currentDate",currentFullCalendar.currentData.currentDate)
  },
  calendarnext() {
    currentFullCalendar.next();
    amplify.publish("calendar.currentDate",currentFullCalendar.currentData.currentDate)
  },
  calendarprev() {
    currentFullCalendar.prev();
    amplify.publish("calendar.currentDate",currentFullCalendar.currentData.currentDate)
  },
  paginationnext() {
    navigationContext.page = Math.min(navigationContext.page+1,navigationContext.pageCount-1);
    currentFullCalendar.refetchResources()
    currentFullCalendar.render();
  },
  paginationprev() {
    navigationContext.page = Math.max(navigationContext.page-1,0);
    currentFullCalendar.refetchResources()
    currentFullCalendar.render();
  },
  calendarview(value){
    Storage.localSet('settings.calendarView',value);
    currentFullCalendar.changeView(value)
    updateViewSelector()
  },
  calendarsettings() {
    import("./modal_settings.mustache").then(function(TPL){
      modal.openModal(TPL,{
        settings:FwDatas.getSettingsPerFamily(),
        weekdays:DateUtils.getWeekDays()
      });
    });
  },
  calendarclean
  
})

async function updateViewSelector(){
  var lastView = Storage.localGet('settings.calendarView')||'dayGridMonth';
  var selectedMenu = (await actionMenu.getData(null,'calendarview')).menu.find(menuItem=>menuItem.onclick==='calendarview|'+lastView);
  $('[data-key="calendarview"]').html(`<icon style="font-size:24px">${selectedMenu.svg}</icon><span>${i18n.get(selectedMenu.i18nkey)}</span><icon style="font-size:24px">${Icons.ic_chevron_down}</icon>`)
  
  var 
    memberorderData = await MemberOrder.need(),
    isAllSelected = memberorderData.filter(member=>!member.activated).length===0,
    selectedCount = memberorderData.filter(member=>member.activated).length,
    button = $('*[data-fw-onclick="memberordersettings"]');

    if(isAllSelected){
      button.html(`
        <icon style="font-size:24px">${Icons.ic_group}</icon>
        <flexauto>${i18n.get('calendarmember.members')}</flexauto>
      `).removeClass('selected')
    }else{
      button.html(`
        <icon style="font-size:24px">${Icons.ic_group}</icon>
        <flexauto>${i18n.get('calendarmember.members')} (${selectedCount})</flexauto>
        <icon data-fw-onclick="memberorderclear" class="rounded" style="font-size:20px;padding:2px;background-color:${getComputedColorVariable('--brand-color').setOpacityPercent(30)}">${Icons.ic_close}</icon>
      `).addClass('selected')
    }
    
  
  if(navigationContext.pageCount===1 || lastView!=='resourceTimeGridDay'){
    $('.paginationnav').hide()
  }else{
    var navigationContainer = $('.paginationnav').show();
    navigationContainer.find('.paginationtext').text((navigationContext.page+1)+'/'+navigationContext.pageCount);
    navigationContainer.find('[data-fw-onclick="paginationprev"]').toggleClass('disabled',navigationContext.page===0)
    navigationContainer.find('[data-fw-onclick="paginationnext"]').toggleClass('disabled',navigationContext.page===navigationContext.pageCount-1)
    
  }
}

INR.onPage(INR.URL.EVENTS,async function(){
  
  //TODO remove this invalidate, but test a lot before
  EventStore.invalidate();
  selectedCalendarIds = null;
  
  if(libLocation.getURLParam('googlereturn') && !libLocation.getURLParam('error')){
    ApiServer.googlelogin2(libLocation.getURLParam('code'),function(credential){
      import("../modal/calgoogle_edit.mustache").then(function(TPL){
        modal.openModal(TPL,credential);
      });
    },function(){
      libLocation.goTo('events.php');
    })
  }
  if(FwDatas.getState().timeZone !== OS.getTimeZone()){
    modal.toast({
      emoji:'🕰️',
      text:'timezone.changealerttitle',
      button:[{title:"actions.learnmore",onclick(){
        modal.ask({
          title:'timezone.changealerttitle',
          message:'timezone.changealertdescription',
          lottie:"images/lottie/anim_clock.json",
          button:[{title:'OK'}]
        })
      }}]
    })
    ApiServer.accgetstate(deviceId, "WebFirebase", FizConfig.jsVersion||"",OS.getTimeZone()).then((accountState=>{
      FwDatas.setState(accountState);
    }))
  }
  
  var lastView = Storage.localGet('settings.calendarView')||'dayGridMonth';
  if(["timeGridDay","timeGridWeek","dayGridMonth","listYear","resourceTimeGridDay"].indexOf(lastView)===-1){
    lastView = 'dayGridMonth'
  }
  
  var 
    userSettings = FwDatas.getSettingsPerFamily()||{},
    scheduleResources = async function(){
      var 
        selectedRessource = (await MemberOrder.refresh()).filter(a=>a.activated===true).map(enrichedMember=>{
        
          return {
            id:enrichedMember.member.accountId, 
            title:enrichedMember.member.firstName,
            sortingIndex :enrichedMember.sortingIndex
          }
        }),
        paginationSize = Math.ceil((document.getElementById("fullcalendar").clientWidth - 50)/100);

      navigationContext.pageCount = Math.ceil(selectedRessource.length/paginationSize)
      if(navigationContext.page>=navigationContext.pageCount){
        navigationContext.page = navigationContext.pageCount-1;
      }
      updateViewSelector()
      return selectedRessource.slice(navigationContext.page*paginationSize,navigationContext.page*paginationSize+paginationSize)  
    }

  currentFullCalendar = new Calendar(document.getElementById("fullcalendar"),{
    nowIndicator:true,
    allDayText: i18n.get('new_event.allday'),
    resourceOrder :'sortingIndex',
    resources:scheduleResources,
    resourceLabelContent(data : {date:Date,resource:ResourceApi ,view :ViewImpl}){
      var user = FwDatas.getProfile(data.resource.id);
      return {html:`<img class="fw-avatar" style="margin-bottom:8px" src="${user.medias[0].url(120,120,'c')}"><br/>${user.firstName}`}
    },
    initialView:lastView,
    locale: i18n.getSelectedLanguage(),
    weekNumbers:userSettings.calendarWeekNb,
    firstDay:userSettings.calendarFirstDayOfWeek%7,
    scrollTime:'08:00:00',
    height:"parent",
    editable: true,
    //buttonText:i18n.get('eventCalendarNav'),
    headerToolbar: false,
    views: {
      dayGridMonth: { // name of view
        eventTimeFormat: { hour: 'numeric', minute: '2-digit', omitZeroMinute: true, meridiem: 'short' }
      },
      week: { // name of view
        eventTimeFormat: { hour: 'numeric', minute: '2-digit', meridiem: 'short' }
      },
      day: { // name of view
        eventTimeFormat: { hour: 'numeric', minute: '2-digit', meridiem: 'short' }
      }
    },
    listDayFormat:function(info){
      var date = new Date(info.date.marker.toISOString().substring(0,10)+'T00:00:00')
      return DateUtils.format(date,'dddd LL')
    },
    eventDisplay:'block',
    datesSet:function(info){
      $('#calendartitledisplay').text(info.view.title);
      if(info.view.type==='listYear'){
        function autoscroll(){
          let 
            allDates = $('[data-date]'), 
            smallerBefore = null;
          for(let i=0;i<allDates.length;i++){
            let elem = allDates.get(i);
            if(new Date(elem.getAttribute('data-date'))<new Date()){
              smallerBefore = elem;
            }else{
              break;
            }
          }
          if(smallerBefore){
            smallerBefore.scrollIntoView();
          }
        }
        setTimeout(autoscroll,400)
      }
    },
    events: function(range, successCallback,failureCallback){
      
      MemberOrder.need().then(async ()=>{
        var data = await MemberOrder.need()
        if(data.filter(info=>!info.activated).length===0){
          return []
        }
        return data.filter(info=>info.activated).map(info=>info.member.accountId)
      }).then(selectedMembers=>{
        EventStore.loadEventsBySync(selectedCalendarIds,selectedMembers,range).then(evts=>{
          var allmembersids = MemberOrder.datas.map(info=>info.member.accountId)
          successCallback(evts.map(function(ev){
            var color = ev.calendar.color;
            if(ev.calendar.useEventColor && ev.color){
              color = ev.color
            }
            /*
            if(ev.computedComplete){
              color = "#ccc"
            }
            */  
            var resourceIds = ev.toAll?allmembersids:ev.attendeeIds;
            
            return {
              start:ev.start,
              end:ev.allDay?new Date(new Date(ev.end).getTime()+1000) :ev.end,
              title:ev.private?'🔒 '+ev.title:ev.title,
              color:color,
              id:ev.metaId,
              allDay:ev.allDay,
              resourceIds,
              editable:ev.draggable,
              durationEditable :!ev.isTaskEvent && !ev.isMealplannerEvent,
              resourceEditable:ev.draggable && !ev.isMealplannerEvent
            }
          }))
        },failureCallback);
      })
    },
    selectable:true,
    select(selectionInfo : selectionInfo ){
      var 
        start = new Date(selectionInfo.start),
        end = new Date(selectionInfo.end);
      if(selectionInfo.allDay){
        end.setDate(end.getDate()-1);
        start.setHours(9);
        end.setHours(10);
      }
      calendar_modal.createEvent(selectionInfo.start,end,selectionInfo.allDay, undefined,selectionInfo.resource);  
      
    },
    eventClick: function(obj){
      var id = obj.event.id;
      Html.trigger($(this),"evtclick",[id])
    },
    eventResize: eventModified,
    eventDrop
  });
  
  
  
  INR.subscribe("eventCreated eventUpdated eventDeleted contactUpdated",function(iEvent){
    EventStore.invalidate((metaId :string)=>metaId.startsWith('calendar/'));
    if(iEvent){
      memberToggleFilter(true,...iEvent.attendeeIds);
    }
    currentFullCalendar.refetchEvents();
  });
  INR.subscribe("taskNeedRefresh",function(){
    currentFullCalendar.refetchEvents();
  });
  INR.subscribe("calendarSelection",function(selected){
    selectedCalendarIds = selected;
    currentFullCalendar.refetchEvents();
  });
  INR.subscribe("calendarModification",function(selected){
    selectedCalendarIds = selected;
    //maybe no need to do that here
    EventStore.invalidate();
    currentFullCalendar.refetchEvents();
  });
  
  INR.subscribe('timetableUpdated',function(fresh){
    modal.closeModal();
    EventStore.invalidate(metaId=>metaId.startsWith('calendarTimetable/'));
    currentFullCalendar.refetchEvents();
  })
  INR.subscribe("calendarNeedRender resized",function(){
    currentFullCalendar.render();
  });
  INR.subscribe("DatePicker",function(date : Date){
    
    currentFullCalendar.gotoDate(date);
  });
  INR.subscribe("familyMemberChange",function(date : Date){
    currentFullCalendar.refetchResources();
    currentFullCalendar.refetchEvents();
    currentFullCalendar.render();
  });
  
  function render(){
    currentFullCalendar.render();
    amplify.publish("calendar.currentDate",currentFullCalendar.currentData.currentDate)
  }
  //FIXME hack because calendar is not displayed and cannot understand why
  setTimeout(render,1);  
 
  ApiServer['custom.calendarsettingssetperfamily'] = function(form,success,error){
    let
      calendarWeekNb = $(form.calendarWeekNb).val(),
      calendarFirstDayOfWeek = $(form.calendarFirstDayOfWeek).val(),
      defaultReminderType = 'NONE',
      defaultReminderUnit = undefined,
      defaultReminderValue = undefined,
      defaultReminderDatas = $(form.defaultReminder).val().split('-');
    
    if(defaultReminderDatas.length>1){
      defaultReminderType = 'SNOOZE';
      defaultReminderUnit = defaultReminderDatas[0];
      defaultReminderValue = defaultReminderDatas[1];
    }
    
    ApiServer.settingssetperfamily(new ApiServer.types.ISettingsPerFamily({
      defaultReminderType,
      defaultReminderUnit,
      defaultReminderValue,
      calendarWeekNb,
      calendarFirstDayOfWeek
    }),function(settingsPerFamily){
      FwDatas.setSettingsPerFamily(settingsPerFamily);
      modal.closeModal();
      libLocation.refresh();
    },success,error)
  }
  
  
  checkEventLimit()
  

  
});